import { FC, PropsWithChildren } from "react";

import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";

import { initAppInsights } from "./app-insights.utils";

export const AnalyticsProvider: FC<PropsWithChildren> = ({ children }) => {
  const appInsightPlugin = initAppInsights();
  return (
    <AppInsightsContext.Provider value={appInsightPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
};
